import { memo } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';

function WhySacem({ colors }) {
  return (
        <Box id="home-sacem" sx={{ py: { xs: 6, md: 10 } }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              fontWeight: 700,
              mb: 2,
              color: colors.textPrimary,
              fontSize: { xs: '2rem', md: '2.5rem' },
            }}
          >
            Pourquoi déclarer à la SACEM ?
          </Typography>
          <Typography
            variant="body1"
            sx={{ textAlign: 'center', color: colors.textSecondary, mb: 6, maxWidth: '600px', mx: 'auto' }}
          >
            Chaque diffusion de votre musique génère des droits. Sans déclaration, ces droits ne vous parviennent jamais.
          </Typography>

          <Box
            sx={{
              mb: 6,
              p: { xs: 3, md: 4 },
              bgcolor: 'rgba(129,140,248,0.08)',
              border: '1px solid rgba(129,140,248,0.2)',
              borderRadius: 3,
              textAlign: 'center',
            }}
          >
            <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 700, mb: 1 }}>
              La SACEM redistribue plus de 1,5M d'euros par an à ses membres
            </Typography>
            <Typography variant="body1" sx={{ color: colors.textSecondary }}>
              Chaque œuvre non déclarée est une part de ces droits qui ne vous revient pas.
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {[
              {
                emoji: '📻',
                title: 'Radio, streaming, TV',
                description: 'Chaque fois que votre chanson passe à la radio, sur Spotify, Apple Music ou à la télévision, la SACEM perçoit des droits en votre nom. Sans déclaration, ces sommes ne vous sont jamais reversées.',
                color: colors.primaryLight,
              },
              {
                emoji: '🎤',
                title: 'Concerts et spectacles',
                description: 'Lorsque votre œuvre est interprétée en live — par vous ou par d\'autres artistes — des droits de représentation sont dus. La SACEM les collecte et les redistribue aux ayants droit déclarés.',
                color: colors.success,
              },
              {
                emoji: '🎬',
                title: 'Synchronisation et publicité',
                description: 'Films, séries, publicités, jeux vidéo... L\'utilisation de votre musique dans des œuvres audiovisuelles génère des droits de synchronisation. Seules les œuvres déclarées peuvent en bénéficier.',
                color: colors.warning,
              },
              {
                emoji: '⚖️',
                title: 'Protection juridique',
                description: 'La déclaration SACEM établit officiellement la paternité de votre œuvre avec une date certaine. C\'est votre première ligne de défense en cas de plagiat ou de litige sur la propriété intellectuelle.',
                color: colors.info,
              },
              {
                emoji: '🌍',
                title: 'Droits internationaux',
                description: 'La SACEM est membre de la CISAC, réseau mondial de sociétés d\'auteurs. Une déclaration en France vous protège et vous permet de percevoir des droits dans plus de 120 pays.',
                color: colors.secondary,
              },
              {
                emoji: '💶',
                title: 'Revenus passifs',
                description: 'Les droits d\'auteur continuent d\'être perçus pendant toute la durée de protection de l\'œuvre (70 ans après le décès de l\'auteur). Une déclaration aujourd\'hui, c\'est un revenu pour des décennies.',
                color: colors.error,
              },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    bgcolor: colors.bgPaper,
                    border: `1px solid ${colors.border}`,
                    borderRadius: 3,
                    p: 3,
                    height: '100%',
                    transition: 'all 0.3s',
                    '&:hover': {
                      borderColor: item.color,
                      transform: 'translateY(-4px)',
                      boxShadow: `0 12px 24px ${item.color}20`,
                    },
                  }}
                >
                  <Typography sx={{ fontSize: 36, mb: 2 }}>{item.emoji}</Typography>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5, color: colors.textPrimary }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: colors.textSecondary, lineHeight: 1.7 }}>
                    {item.description}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

        </Box>
  );
}

export default memo(WhySacem);
